export default {
  applied: '#32B4F2',
  applying: '#FF4090',
  following: '#FFB75F',
}
